import "./App.css"
import "./styles/main.scss"
import AuthProvider from "./components/AuthProvider/AuthProvider"
import MainContext from "./context"
import Routes from "./routes"
import ThemeWrapper from "./theme"

const App = () => {
	return (
		<div className="App">
			<AuthProvider>
				<ThemeWrapper>
					<MainContext>
						<Routes />
					</MainContext>
				</ThemeWrapper>
			</AuthProvider>
		</div>
	)
}

export default App
